import React, { useState, useRef, useEffect } from 'react'
import styles from './index.module.css'
import { isdCodeRegex } from '../../../common/lib/utils/regex_cheat_sheet'
import { VmsInputText } from '@/components/vms-components/InputText/index'
import { VmsButton } from '@/components/vms-components/button/index'
import { onlyNumber } from '../../../common/lib/utils/regex_cheat_sheet'

const OTPInput = ({
  length,
  onSubmit,
  exp_time,
  onResendOtp,
  css,
  isOtpValid,
  isSingleInput = false,
  onClickLoginLoader,
  otpErr,
  isSendOtp,
}) => {
  const isShowSingleInput = isSingleInput ? true : false
  const [otp, setOTP] = useState(isShowSingleInput ? '' : Array(length).fill(''))
  const [minutes, setMinutes] = useState()
  const [seconds, setSeconds] = useState()
  const [disable, setDisable] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const inputRefs = useRef([])

  useEffect(() => {
    convertTime(exp_time)
    setDisable(false)
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds((prevSeconds) => prevSeconds - 1)
      } else {
        if (minutes === 0) {
          clearInterval(interval)
        } else {
          setMinutes((prevMinutes) => prevMinutes - 1)
          setSeconds(59)
        }
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [seconds, minutes])

  const convertTime = (time) => {
    setMinutes(Math.floor(time / (1000 * 60)))
    setSeconds(Math.floor((time % (1000 * 60)) / 1000))
  }

  const handleChange = (indexOrValue, value) => {
    if (isShowSingleInput) {
      // When single input mode, first parameter is the actual value
      const inputValue = indexOrValue;
      let regexNum = inputValue.replace(onlyNumber, "");
      if (!regexNum) {
        setOTP(inputValue);
      }
    } else {
      // When multiple input mode, first parameter is index
      const index = indexOrValue;
      const newOTP = [...otp];
      newOTP[index] = value;
      setOTP(newOTP);

      const nextIndex = index + 1;
      if (nextIndex < inputRefs.current.length) {
        inputRefs.current[nextIndex].focus();
      }
    }
  };
  
  const handlePaste = (index, e) => {
    e.preventDefault();
    const clipboardData = e.clipboardData.getData('text');
    const pastedDigits = clipboardData.match(/\d/g);
    if (pastedDigits && pastedDigits.length === length - index) {
      const newOTP = [...otp];
      for (let i = 0; i < pastedDigits.length; i++) {
        newOTP[index + i] = pastedDigits[i];
      }
    } else {
      // Only allow numbers in multi-input mode
      const newValue = value.replace(isdCodeRegex, '')
      const newOTP = [...otp]
      newOTP[index] = newValue
      setOTP(newOTP)

      const nextIndex = index + 1
      if (newValue && nextIndex < inputRefs.current.length) {
        inputRefs.current[nextIndex].focus()
      }
    }
  }


  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && index > 0 && !otp[index]) {
      e.preventDefault()
      const newOTP = [...otp]
      newOTP[index - 1] = ''
      setOTP(newOTP)
      inputRefs.current[index - 1].focus()
    }
  }

  const handleSubmit = () => {
    const otpValue = isShowSingleInput ? otp : otp.join('')
    if (otpValue !== '' && otpValue.length == length) {
      setDisable(true)
    } else {
      setDisable(false)
    }
    onSubmit(otpValue)
  }

  const resendOtp = () => {
    convertTime(exp_time)
    setDisable(false)
    onResendOtp()
  }

  const handleTogglePassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <>
      {isShowSingleInput ? (
        <div className={styles.mainotp}>
          {false && (
            <div className={styles.mainotptext}>
              <span>{`Kindly enter the ${length} digit OTP sent to your registered email id`}</span>
            </div>
          )}
          <div className={styles.otpboxesmain_input}>
            <VmsInputText
              id="fname"
              type={showPassword ? 'text' : 'password'}
              placeholder="Please enter OTP"
              maxLength={length}
              onChange={(e) => handleChange(e.target.value)}
            />

            {otpErr !== '' ? <div className={styles.email_error_msgotp}>{otpErr}</div> : ''}
            <div className={styles.pass_icon_single}>
              <img
                src={showPassword ? 'theme4/view-icon.svg' : 'theme4/hide-icon-01.svg'}
                alt="pass"
                onClick={() => {
                  handleTogglePassword()
                }}
              />
            </div>
            <label for="otp">OTP</label>
          </div>

          {(seconds > 0 || minutes > 0) && (
            <div className={styles.timeoutotp_single}>
              {' '}
              {minutes < 10 ? `Resend OTP in 0${minutes}` : minutes} :{' '}
              {seconds < 10 ? `0${seconds}seconds.` : seconds} Seconds
            </div>
          )}
          {seconds === 0 && minutes === 0 && (
            <button className={styles.btn_login} onClick={resendOtp}>
              Resend OTP
            </button>
          )}
          {false && (
            <div className={styles.login__actions}>
              <VmsButton
                onClick={handleSubmit}
                disabled={(seconds === 0 && minutes === 0) || (disable && isOtpValid) || isOtpValid}
              >
                Verify OTP
              </VmsButton>
            </div>
          )}
          <div
            className={`${styles.login__actions} ${onClickLoginLoader ? styles.loader_center : ''}`}
          >
            {(seconds > 0 || minutes > 0) && (
              <div className={` ${styles.buttoncontainer}`}>
                <VmsButton
                  // additionalClassName={`${styles.sign_in_btn}`}

                  additionalClassName={`${styles.sign_in_btn} ${onClickLoginLoader ? styles.loading : ''}`}
                  onClick={handleSubmit}
                  disabled={
                    (seconds === 0 && minutes === 0) || (disable && isOtpValid) || isOtpValid
                  }
                >
                  {!onClickLoginLoader ? (
                    <span> VERIFY </span>
                  ) : (
                    <div className={styles.otpInput_loading_spinner}></div>
                  )}
                </VmsButton>{' '}
              </div>
            )}

            {seconds === 0 && minutes === 0 && (
              <div className={styles.email_error_msgotp}>{'OTP has expired'}</div>
            )}
          </div>
        </div>
      ) : (
        <div className={styles.mainotp}>
          <div className={styles.mainotptext}>
            <span>{`Kindly enter the ${length} digit OTP sent to your registered email id`}</span>
          </div>
          <div className={styles.otpboxesmain}>
            {otp.map((digit, index) => (
              // <input
              //   key={index}
              //   type="text"
              //   maxLength={1}
              //   value={digit}
              //   onChange={(e) => handleChange(index, e.target.value.replace(isdCodeRegex, ''))}
              //   ref={(ref) => (inputRefs.current[index] = ref)}
              //   onPaste={(e) => handlePaste(index, e)}
              //   onKeyDown={(e) => handleKeyDown(index, e)}
              // />
              <input
                key={index}
                type="text"
                maxLength={1}
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                ref={(ref) => (inputRefs.current[index] = ref)}
                onPaste={(e) => handlePaste(index, e)}
                onKeyDown={(e) => handleKeyDown(index, e)}
              />
            ))}
          </div>
          {(seconds > 0 || minutes > 0) && (
            <button
              className={css.btn_login}
              onClick={handleSubmit}
              disabled={(seconds === 0 && minutes === 0) || (disable && isOtpValid) || isOtpValid}
            >
              Verify OTP
            </button>
          )}
          {(seconds > 0 || minutes > 0) && (
            <div className={styles.timeoutotp}>
              {' '}
              {minutes < 10 ? `0${minutes}` : minutes} : {seconds < 10 ? `0${seconds}` : seconds}
            </div>
          )}
          {seconds === 0 && minutes === 0 && (
            <button className={css.btn_login} onClick={resendOtp}>
              Resend OTP
            </button>
          )}
          {seconds === 0 && minutes === 0 && (
            <div className={css.email_error_msgotp}>{'OTP has expired'}</div>
          )}
        </div>
      )}
    </>
  )
}

export default OTPInput
